import React, { createContext, useContext } from 'react';

const StorePageContext = createContext();

export const StorePageProvider = ({ children, store, storeId }) => {
  const value = {
    store,
    storeId,
  };

  return (
    <StorePageContext.Provider value={value}>
      {children}
    </StorePageContext.Provider>
  );
};

export const useStorePage = () => {
  const context = useContext(StorePageContext);
  if (!context) {
    throw new Error('useStorePage must be used within a StorePageProvider');
  }
  return context;
};
